import React from 'react';
import { Switch, FormControl, FormGroup, FormControlLabel } from '@material-ui/core';

export default function ToggleSetting({onChange = () => {}, label = "View Archived", labelPlacement="top", color="primary", className}) {
    return (
        <FormControl component="fieldset" className={className}>
            <FormGroup aria-label="position" row>
                <FormControlLabel
                    control={<Switch color={color} onChange={onChange}/>}
                    label={label}
                    labelPlacement={labelPlacement}
                />
            </FormGroup>
        </FormControl>
    );
}


// WEBPACK FOOTER //
// ./src/components/toggleSetting/ToggleSetting.jsx